export const ADD_TRANSACTION = "/custom-transactions/add";
export const REMOVE_TRANSACTION = "/custom-transactions/remove";
